module.exports = __webpack_public_path__ + "img/6.d154e4e3.jpg";